import axios from "axios";
import { store } from "../store";

const s10ApiRequest = axios.create({
  baseURL: process.env.REACT_APP_COLLABORATORS_S10_API,
	headers: {
		'x-api-key': process.env.REACT_APP_EMPLOYEE_PORTAL_API_KEY,
		moduleId: process.env.REACT_APP_MODULE_ID,
		env: process.env.REACT_APP_ENV,
	}
});

export interface NotificationConfig {
  TypeId: number;
  IsActive: boolean;
  NotificationBody: string | null;
  CreationUser?: string;
  CreationDate?: string;
  ModificationUser?: string;
  ModificationDate?: string;
  Id?: number;
}

export const getNotificationConfiguration = async (): Promise<NotificationConfig[]> => {
  const authCompanySelectedState = store.getState().auth.companyselected;
  const headers = {
    token: authCompanySelectedState?.Token,
  };
  const response = await s10ApiRequest.get('/api/NotificationConfiguration/GetNotificationConfiguration', { headers });
  return response.data;
};

export const updateNotificationConfiguration = async (typeId: number, isActive: boolean): Promise<void> => {
  const authCompanySelectedState = store.getState().auth.companyselected;
  const headers = {
    token: authCompanySelectedState?.Token,
  };
  await s10ApiRequest.post('/api/NotificationConfiguration/UpdateNotificationConfiguration', { TypeId: typeId, IsActive: isActive }, { headers });
};

export const updateTemplateNotification = async (typeId: number, notificationBody: string): Promise<void> => {
  const authCompanySelectedState = store.getState().auth.companyselected;
  const headers = {
    token: authCompanySelectedState?.Token,
  };
  await s10ApiRequest.post('/api/NotificationConfiguration/UpdateTemplateNotification', { TypeId: typeId, NotificationBody: notificationBody }, { headers });
};